import React from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";

/**
 * DialogTitle component wrapper for dialog titles.
 * Wraps Material-UI DialogTitle for consistent imports.
 * 
 * @component
 * @example
 * <DialogTitle>Dialog Title</DialogTitle>
 */
const DialogTitle = ({ children, ...props }) => {
  return <MuiDialogTitle {...props}>{children}</MuiDialogTitle>;
};

DialogTitle.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, the children won't be wrapped in a Typography component
   */
  disableTypography: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default DialogTitle;
